
import { DataType } from '../../../../../models/Enums';
import ValidationRuleModel, { IValidationRuleProvider } from '../../../../../models/ValidationRuleModel';

/** Service level summary validation rules */
const ValidationRules: IValidationRuleProvider = {
    observedDataQualityResultReason: new ValidationRuleModel(DataType.String, true)
}

export default ValidationRules;